<template>
	<c-dialog ref="dialog" title="排产分析" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<module>
			<module-row ref="upTab" size="40%" tab-type="border-tab">
				<module-tab name="订单明细" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="productTable" view-id="20012" height="grow" readonly>
							<template #aux_unit_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>单位转换倍率说明：</p>
										<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
										<p>销售数量（辅单位）* 换算率 = 产品数量（主单位）</p>
										<p>如：1（kg） * 1000 = 1000（g）</p>
										<p>换算率修改后系统会自动计算产品数量</p>
									</template>
								</c-tooltip>
							</template>
							
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--待发货数-->
							<template #wait_deliver_count="{data}">
								<span v-if="data.main_product_count-data.deliver_count <=0">0</span>
								<span v-else style="color:red;font-weight: bold;font-size: 16px;">{{parseFloat((data.main_product_count-data.deliver_count).toFixed(2))}}</span>
							</template>
							<!--待发货数-合计行-->
							<template #wait_deliver_count_summed="{total}">
								<span style="color:red;font-weight: bold;font-size: 16px;">{{total}}</span>
							</template>
							
							<!--可发货数-->
							<template #can_deliver_count="{data}">
								<span v-if="data.can_deliver_count <=0">0</span>
								<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.can_deliver_count}}</span>
							</template>
							
							<template #can_deliver_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>可发货计算公式：</p>
										<p>可发货数 = (库存数-占用数) > (订单数-已发货数) ? (订单数-已发货数) ：(库存数-占用数)</p>
									</template>
								</c-tooltip>
							</template>
							
							<!--需外购成品-->
							<template #need_purchase_product="{data}">
								<span v-if="data.need_purchase_product <=0">0</span>
								<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.need_purchase_product}}</span>
							</template>
							
							<template #need_purchase_product_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>计算前提：产品来源为采购</p>
										<p>需外购成品计算公式：</p>
										<p>需外购成品数 = (订单数-已发货数)-库存数+占用数+最小安全库存-入库待审核数-采购待入库数</p>
									</template>
								</c-tooltip>
							</template>
							
							<!--需排产-->
							<template #need_product="{data}">
								<span v-if="data.need_product <=0">0</span>
								<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.need_product}}</span>
							</template>
							
							<template #need_product_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>计算前提：产品来源为自产</p>
										<p>需排产成品计算公式：</p>
										<p>需排产成品数 = (订单数-已发货数)-库存数+占用数+最小安全库存-入库待审核数-生产中</p>
									</template>
								</c-tooltip>
							</template>
						</custom-table>
					</div>
				</module-tab>

				<!-- <module-tab name="物料清单">
					<div class="m-detail-box">
						<custom-table ref="materialTable" view-id="20001" readonly>
						</custom-table>
					</div>
				</module-tab> -->

				<template #foot>
					<div class="foot flex-between-center">
						<c-checkbox-group ref="analyseConfig" class="flex-grow">
							<c-checkbox value="1">考虑库存占用</c-checkbox>
							<c-checkbox value="2">考虑安全库存</c-checkbox>
							<c-checkbox value="3">考虑预计入库量</c-checkbox>
						</c-checkbox-group>

						<div class="flex-grow">
							<c-button color="main" size="form" @click="analyseHandle()">开始智能分析</c-button>
						</div>
					</div>
				</template>
			</module-row>

			<module-row ref="downTab" tab-type="border-tab">
				<module-tab :name="`可发货产品${finishCount ? ` (${finishCount})` : ''}`" enable-flex @activated="currentTab = 0">
					<div class="m-detail-box">
						<custom-table ref="finishTable" view-id="20013" selector height="grow" readonly>
							<template #empty>
								<c-empty message="暂无可发货产品"></c-empty>
							</template>

							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--待发货数-->
							<template #wait_deliver_count="{data}">
								<span v-if="data.main_product_count-data.deliver_count <=0">0</span>
								<span v-else style="color:red;font-weight: bold;font-size: 16px;">{{parseFloat((data.main_product_count-data.deliver_count).toFixed(2))}}</span>
							</template>
							<!--待发货数-合计行-->
							<template #wait_deliver_count_summed="{total}">
								<span style="color:red;font-weight: bold;font-size: 16px;">{{total}}</span>
							</template>
							
							<!--可发货数-->
							<template #can_deliver_count="{data}">
								<span v-if="data.can_deliver_count <=0">0</span>
								<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.can_deliver_count}}</span>
							</template>
							
							<template #can_deliver_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>可发货计算公式：</p>
										<p>可发货数 = (库存数-占用数) > (订单数-已发货数) ? (订单数-已发货数) ：(库存数-占用数)</p>
									</template>
								</c-tooltip>
							</template>
						</custom-table>
					</div>

					<template #button>
						<c-button size="form" color="main" prepend-icon="tf-order" @click="deliverHandle">生成发货单</c-button>
					</template>
				</module-tab>

				<module-tab :name="`采购建议${purchaseCount ? ` (${purchaseCount})` : ''}`" @activated="currentTab = 1">
					<div class="m-detail-box">
						<div v-show="!materialsPurchaseCount || productPurchaseCount">
							<c-title>成品采购</c-title>
							<custom-table ref="finishPurchaseTable" view-id="20014" selector readonly>
								<template #empty>
									<c-empty message="暂无需采购成品"></c-empty>
								</template>

								<!--产品来源-->
								<template #product_source="{data}">
									<c-state dict="productSourceName" :value="data.product_source"></c-state>
								</template>
								
								<!--产品类型-->
								<template #product_type="{data}">
									<c-state dict="productTypeName" :value="data.product_type"></c-state>
								</template>
								
								<!--待发货数-->
								<template #wait_deliver_count="{data}">
									<span v-if="data.main_product_count-data.deliver_count <=0">0</span>
									<span v-else style="color:red;font-weight: bold;font-size: 16px;">{{parseFloat((data.main_product_count-data.deliver_count).toFixed(2))}}</span>
								</template>
								<!--待发货数-合计行-->
								<template #wait_deliver_count_summed="{total}">
									<span style="color:red;font-weight: bold;font-size: 16px;">{{total}}</span>
								</template>
								
								<!--需外购成品-->
								<template #need_purchase_product="{data}">
									<span v-if="data.need_purchase_product <=0">0</span>
									<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.need_purchase_product}}</span>
								</template>
							</custom-table>
						</div>

						<div v-show="materialsPurchaseCount">
							<c-title>物料采购</c-title>
							<custom-table ref="materialPurchaseTable" view-id="20015" selector readonly>
								<template #empty>
									<c-empty message="暂无需采购物料"></c-empty>
								</template>

								<!--产品来源-->
								<template #product_source="{data}">
									<c-state dict="productSourceName" :value="data.product_source"></c-state>
								</template>
								
								<!--产品类型-->
								<template #product_type="{data}">
									<c-state dict="productTypeName" :value="data.product_type"></c-state>
								</template>
								
								<!--需采购物料-->
								<template #need_product="{data}">
									<span v-if="data.need_product <=0">0</span>
									<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.need_product}}</span>
								</template>
							</custom-table>
						</div>
					</div>

					<template #button>
						<c-button size="form" color="main" prepend-icon="tf-order" @click="purchaseHandle">生成采购单</c-button>
					</template>
				</module-tab>

				<module-tab :name="`生产建议${planCount ? ` (${planCount})` : ''}`" enable-flex @activated="currentTab = 2">
					<div class="m-detail-box">
						<custom-table ref="planTable" view-id="20016" selector height="grow" readonly>
							<template #empty>
								<c-empty message="暂无生产建议"></c-empty>
							</template>

							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--需排产-->
							<template #need_product="{data}">
								<span v-if="data.need_product <=0">0</span>
								<span v-else style="color:blue;font-weight: bold;font-size: 16px;">{{data.need_product}}</span>
							</template>
						</custom-table>
					</div>

					<template #button>
						<c-button size="form" color="main" prepend-icon="tf-order" @click="planHandle">批量生成工单</c-button>
					</template>
				</module-tab>
			</module-row>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				finishCount: 0,
				productPurchaseCount: 0,
				materialsPurchaseCount: 0,
				planCount: 0,
				currentTab: 0
			}
		},

		computed: {
			purchaseCount() {
				return this.productPurchaseCount + this.materialsPurchaseCount;
			}
		},

		methods: {
			open(data) {
				this.id = data.id;
				this.$refs.analyseConfig.set(["1","3"]);
				this.analyseHandle(true);
				this.$refs.upTab.changeIndex(0);
				this.$refs.downTab.changeIndex(0);
			},
			
			analyseHandle(init) {
				this.request({
					url: '/order/transfer_analysis',
					data: {
						id: this.id,
						config: this.$refs.analyseConfig.get()
					},
					loading: true,
					success: data => {
						if (init) {
							this.$refs.productTable.init();
							// this.$refs.materialTable.init();
							this.$refs.finishTable.init();
							this.$refs.finishPurchaseTable.init();
							this.$refs.materialPurchaseTable.init();
							this.$refs.planTable.init();
							this.$refs.dialog.open();
						}

						this.$refs.productTable.$refs.list.setData(data.productList);
						// this.$refs.materialTable.$refs.list.setData(data.productList);
						this.$refs.finishTable.$refs.list.setData(data.canDeliverList);
						this.$refs.finishPurchaseTable.$refs.list.setData(data.needPurchaseList);
						this.$refs.materialPurchaseTable.$refs.list.setData(data.needPurchaseBomList);
						this.$refs.planTable.$refs.list.setData(data.needProductionList);

						this.finishCount = data.canDeliverList.length;
						this.productPurchaseCount = data.needPurchaseList.length;
						this.materialsPurchaseCount = data.needPurchaseBomList.length;
						this.planCount = data.needProductionList.length;

						if (
							(this.currentTab == 0 && !this.finishCount) ||
							(this.currentTab == 1 && !this.purchaseCount) ||
							(this.currentTab == 2 && !this.planCount)
						) {
							this.$refs.downTab.changeIndex(this.finishCount ? 0 : this.purchaseCount ? 1 : this.planCount ? 2 : 0);
						}
					}
				});
			},

			deliverHandle() {
				let data = this.$refs.finishTable.$refs.list.getData('selected');
				if (!data.length) {
					this.$message({
						message: '请选择要发货的产品'
					});
					return;
				}
				this.globalDialog('orderDeliverEdit', {
					data: {
						orderId: this.id,
						productList: data
					}
				}, ()=>{
					this.analyseHandle();
					this.$emit('resolve');
				});
			},

			purchaseHandle() {
				// 分别获取两份选中数据
				const finishList = this.$refs.finishPurchaseTable.$refs.list.getData('selected');
				const materialList = this.$refs.materialPurchaseTable.$refs.list.getData('selected');
				// 标记来源
				const data = [
				  ...finishList.map(item => ({ ...item, source: 'finish' })),
				  ...materialList.map(item => ({ ...item, source: 'material' }))
				];
				
				if (!data.length) {
					this.$message({
						message: '请选择要采购的产品和物料'
					});
					return;
				}
				this.globalDialog('purchaseOrderEdit', {
					data: {
						orderProductList: data.map(item => {
							item.order_id = this.id;
							// 仅成品采购产品才需要关联明细ID
							if (item.source === 'finish') {
								item.order_product_id = item.id;
							}
							item.main_product_count = item.need_purchase_product || item.need_product;
							return item;
						})
					}
				}, this.analyseHandle);
			},

			planHandle() {
				let data = this.$refs.planTable.$refs.list.getData('selected');
				if (!data.length) {
					this.$message({
						message: '请选择要排产的产品'
					});
					return;
				}
				this.globalDialog('batchWorkEdit', {
					data: {
						ref_type: 1,
						orderProductList: data.map(item => {
							item.main_product_count = item.need_product;
							item.order_product_id = item.id;
							item.ref_type = 1;
							return item;
						})
					}
				}, ()=>{
					this.analyseHandle();
					this.$emit('resolve');
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.foot {
		height: 60px;
		border-top: 1px solid var(--unit-line);
		padding: 0 30px;
		background: #fff;
	}
</style>